module.exports = __webpack_public_path__ + "static/assets/ca977f745ed62116cbba6d4b0d7dc611.png";